import { _ } from "libs";

import React, { useState, useEffect, useRef } from "react";
import moment from "moment-timezone";
import GCDayPicker from "../gcDayPicker";
import GCTimePicker from "../gcTimePicker";
import { getZonedTime, getLocalMomentInZone } from "../../libs/time";

type OnChange = (timestamp: number) => void;

function createTimestamp(day: string, hour: number, timezone: string): number {
	return getZonedTime(`${day} ${hour.toString().padStart(2, "0")}:00`, timezone).unix();
}

const CourtsDateTimePicker = ({
	onChange,
	value,
	timezone,
}: {
	onChange: OnChange;
	value: number;
	timezone: string;
}) => {
	if (!value && timezone) {
		value = getLocalMomentInZone(timezone).unix();
	}
	else {
		value = moment();
	}

	const time = moment
		.unix(value)
		.startOf("hour");
	if(timezone){
		time.tz(timezone);
	}

	const startOfDay = time
		.clone()
		.startOf("day")
		.format("YYYY-MM-DD");

	const selectedHour = useRef(time.hour());
	const selectedDay = useRef(startOfDay);

	useEffect(() => {
		const timestamp = createTimestamp(selectedDay.current, selectedHour.current, timezone);
		onChange(timestamp);
	}, [timezone]);

	const onDayChange = (day: string) => {
		selectedDay.current = day;
		const timestamp = createTimestamp(selectedDay.current, selectedHour.current, timezone);
		onChange(timestamp);
	};

	const onHourChange = (hour: number) => {
		selectedHour.current = hour;
		const timestamp = createTimestamp(selectedDay.current, selectedHour.current, timezone);
		onChange(timestamp);
	};

	return (
		<>
			<div className="field day">
				<label>{_("courtForm.day.label")}</label>
				<GCDayPicker value={selectedDay.current} timezone={timezone} onChange={onDayChange} />
			</div>
			<div className="field time">
				<label>{_("courtForm.time.label")}</label>
				<GCTimePicker dayTimestamp={selectedDay.current} value={selectedHour.current} timezone={timezone} onChange={onHourChange} />
			</div>
		</>
	);
};

export default CourtsDateTimePicker;
